<template>
  <svg :fill="color" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.06,13.06l-8,8c-.59.59-1.54.59-2.12,0l-4-4c-.59-.59-.59-1.54,0-2.12.59-.58,1.54-.59,2.12,0l2.94,2.94,6.94-6.94c.59-.59,1.54-.59,2.12,0s.59,1.54,0,2.12h0ZM16,32c5.72,0,11-3.05,13.86-8,2.86-4.95,2.86-11.05,0-16C27,3.05,21.72,0,16,0S5,3.05,2.14,8c-2.86,4.95-2.86,11.05,0,16,2.86,4.95,8.14,8,13.86,8Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconClock',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
